import React, { useState, useRef, useEffect } from "react";
import { styled } from "../../stitches.config";
import useMediaQuery from "../../helpers/useMediaQuery";

interface ITextWrapper {
    children: React.ReactNode;
    mobileLimit?: number;
    desktopLimit?: number;
    background?: "white" | "black";
}

const TextWrapper: React.FC<ITextWrapper> = ({
    children,
    mobileLimit = 100,
    desktopLimit = 150,
    background = "black",
}) => {
    const [expanded, setExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);

    const contentRef = useRef<HTMLDivElement>(null);

    const isDesktop = useMediaQuery("bp4");

    const currentLimit = isDesktop ? desktopLimit : mobileLimit;

    useEffect(() => {
        if (contentRef.current) {
            setIsOverflowing(
                contentRef.current.scrollHeight > currentLimit
            );
        }
    }, [children, currentLimit]);

    return (
        <Wrapper>
            <Content
                ref={contentRef}
                expanded={expanded}
                showGradient={isOverflowing && !expanded}
                background={background}
                css={{
                    maxHeight: expanded ? "4000px" : `${currentLimit}px`,
                }}
            >
                {children}
            </Content>

            {isOverflowing && !expanded && (
                <ToggleButton onClick={() => setExpanded(true)}>
                    Pokaż więcej
                </ToggleButton>
            )}
        </Wrapper>
    );
};

export default TextWrapper;

const Wrapper = styled("div", {
    position: "relative",
});

const Content = styled("div", {
    overflow: "hidden",
    position: "relative",
    transition: "max-height 0.3s ease",

    variants: {
        expanded: {
            true: {},
        },

        showGradient: {
            true: {},
            false: {},
        },

        background: {
            white: {
                "&::after": {
                    background:
                        "linear-gradient(to bottom, rgba(255,255,255,0) 0%, $grayscale0 100%)",
                },
            },

            black: {
                "&::after": {
                    background:
                        "linear-gradient(to bottom, rgba(0,0,0,0) 0%, $grayscale100Fixed 100%)",
                },
            },
        },
    },

    compoundVariants: [
        {
            showGradient: true,

            css: {
                "&::after": {
                    content: "",
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "40px",
                    pointerEvents: "none",
                    transition: "opacity 0.3s ease",
                },
            },
        },
    ],
});

const ToggleButton = styled("button", {
    marginTop: "12px",
    color: "$primary",
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    padding: 0,

    "&:hover": {
        opacity: 0.8,
    },
});